
/* styles */
require("!!../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-ddc3582a&scoped=true!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SelectizeCategory.vue")

var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SelectizeCategory.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-ddc3582a!../../../../../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SelectizeCategory.vue"),
  /* scopeId */
  "data-v-ddc3582a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/structure/ui/lists/selectize/SelectizeCategory.vue
// module id = 64
// module chunks = 1